import { render, staticRenderFns } from "./PlayerFilterList.vue?vue&type=template&id=35e7dccd"
import script from "./PlayerFilterList.vue?vue&type=script&lang=js"
export * from "./PlayerFilterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports